import { Paper } from "@material-ui/core";
import React from "react";
import useStyles from "./style";
import PesquisaCredito from "../../pages/PesquisaCredito";
import jsondata from "../../test/mock/dinamicComponent";

const ModalRelatorios = (props) => {
  const classes = useStyles();
  return (
    <Paper className={classes.card}>
      <PesquisaCredito
        modelos={props.modelos}
        fecharModal={props.fecharModal}
        submitRelatorio={props.submitRelatorio}
        loading={props.loading}
      />
    </Paper>
  );
};

export default ModalRelatorios;
